import {
  NO_GROUP_FILTER_OPTION_ID,
  NO_TAG_FILTER_OPTION_ID,
  OTHER_DAY_PART_FILTER_OPTION_ID,
} from '../../constants';

const filterTypeToCollection = {
  locationIds: 'locations',
  positionIds: 'positions',
  userIds: 'users',
  groupIds: 'userGroups',
  eventTypes: 'filteredEventTypes',
  acceptanceStatuses: 'acceptanceFilterOptions',
  statusIds: 'statusOptions',
  leaveTypeIds: 'leaveTypeOptions',
  tagIds: 'tags',
  dayPartIds: 'dayParts',
  payTypes: 'payTypes',
  stateIds: 'stateOptions',
  sourceIds: 'sourceOptions',
  isAutoClockOutIds: 'isAutoClockOutOptions',
};

export default function toggleFilter(controller, type, id, selectOnlyThis) {
  if (!(type in controller.filter)) {
    controller.filter[type] = [];
  }

  const typeIndex = controller.filter[type].indexOf(id);
  const collectionName = filterTypeToCollection[type] || type;
  let collection = controller[collectionName];

  if (type === 'groupIds') {
    collection = [...collection, { id: NO_GROUP_FILTER_OPTION_ID }];
  }

  if (type === 'tagIds') {
    collection = [...collection, { id: NO_TAG_FILTER_OPTION_ID }];
  }

  if (type === 'dayPartIds') {
    collection = [...collection, { id: OTHER_DAY_PART_FILTER_OPTION_ID }];
  }

  if (collection.length === 1) {
    return;
  }

  if (controller.filter[type].length === 0) {
    controller.filter[type] = collection
      .filter((item) => (selectOnlyThis ? item.id === id : item.id !== id))
      .map((item) => item.id);

    return;
  }

  if (typeIndex !== -1) {
    controller.filter[type].splice(typeIndex, 1);
    return;
  }

  controller.filter[type].push(id);

  if (controller.filter[type].length === collection.length) {
    controller.filter[type] = [];
  }
}
